import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import VideoGalleryContent from './VideoGalleryContent'
export default class VideoGallery extends Component {

    

    render() {

        let id = this.props.match.params.id;
        return (
            <div className="wrapper">
                <Navbar />
                <Mainmenu />
                <VideoGalleryContent id={id} />
                <Footer />

            </div>


        )
    }
}
